

























import { Component, Prop, Vue } from 'vue-property-decorator'
import { Icon, Pill } from '@alpha/ink'
import { RemovalReasonCopyMap, ResponseRemovalMessaging } from '../Utilities/MessagingUtilities'
import { Response } from '@/store/modules/survey-store-module'
import { RespondentSurveyState } from '@alpha/shared/src/entities/RespondentSurveyEvent'

@Component({
  components: {
    Icon,
    Pill
  }
})
export default class AnswerToggle extends Vue {
  @Prop({ required: true }) removed!: boolean
  @Prop({ required: true }) response!: Response
  @Prop({ required: true }) text!: string
  @Prop({ required: false, default: true }) showToggle!: boolean
  @Prop({ required: false, default: false }) isAlphaAdmin!: boolean

  toggleResponse () {
    this.$emit('toggleResponseRemoval')
  }

  get rejected () {
    return this.response.status === RespondentSurveyState.REJECTED_BY_DS && this.removed
  }

  get hidden () {
    if (this.toggleDisabled) return false // placeholder text is shown at full opacity
    if (this.removed) return true // removed response is shown with low opacity
  }

  get checkboxTooltip () {
    if (this.toggleDisabled) return ResponseRemovalMessaging.ResponseRemoved
    return {
      content: ResponseRemovalMessaging.Accepted,
      container: 'body',
      placement: 'left-end'
    }
  }

  get toggleDisabled () {
    return this.rejected && !this.isAlphaAdmin
  }

  get showReasons (): boolean {
    return !!this.reasons.length && this.rejected
  }

  get reasons () {
    return (this.response.dataQualityCategories || []).map(reason => RemovalReasonCopyMap[reason!])
  }
}
